<template>
  <layouts></layouts>
  <student-breadcrumb :title="title" :text="text" :text1="text1" />

  <div class="page-content course-sec">
    <div class="container">
      <div class="row align-items-center" style="margin-top: 50px;">
        <div class="col-md-12">
          <div class="add-course-header">
            <h2>Criar Usuário Manual</h2>
            <div class="add-course-btns">
              <ul class="nav">
                <li>
                  <router-link to="/caduceus/dashboard" class="btn btn-black">
                    Voltar
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="widget-set">
              <div class="widget-content">
                <div class="add-course-info">
                  <div class="add-course-inner-header">
                    <h4>Informações do Usuário</h4>
                  </div>
                  <div class="add-course-form">
                    <form @submit.prevent="handleSubmit">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="add-course-label">Email *</label>
                            <input
                              type="email"
                              class="form-control"
                              placeholder="email@exemplo.com"
                              v-model="formData.email"
                              required
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="add-course-label">Nome Completo *</label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Nome Completo"
                              v-model="formData.fullName"
                              required
                            />
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="add-course-label">Telefone</label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="(00) 00000-0000"
                              v-model="formData.phone"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="add-course-label">Origem do Usuário</label>
                            <select
                              v-model="formData.userOrigin"
                              class="form-select"
                            >
                              <option :value="null">Selecione uma origem</option>
                              <option value="REDE_LEGOS">Rede Legos</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="add-course-label">Função</label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Ex: Enfermeira do Hospital XXX"
                              v-model="formData.function"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="add-course-label">Senha *</label>
                            <input
                              type="password"
                              class="form-control"
                              placeholder="Mínimo 6 caracteres"
                              v-model="formData.password"
                              minlength="6"
                              required
                            />
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label class="add-course-label">Cursos (Seleção Múltipla)</label>
                            <div v-if="loadingCourses" class="text-muted">
                              Carregando cursos...
                            </div>
                            <div v-else-if="courses.length === 0" class="text-muted">
                              Nenhum curso disponível
                            </div>
                            <div v-else class="course-selection">
                              <div
                                v-for="course in courses"
                                :key="course.id"
                                class="form-check mb-2"
                              >
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  :value="course.id"
                                  :id="`course-${course.id}`"
                                  v-model="formData.courseIds"
                                />
                                <label
                                  class="form-check-label"
                                  :for="`course-${course.id}`"
                                >
                                  {{ course.title }}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group mb-0">
                            <button
                              type="submit"
                              class="btn btn-success-dark"
                              :disabled="saving"
                            >
                              <span
                                v-if="saving"
                                class="spinner-border spinner-border-sm me-1"
                              ></span>
                              {{ saving ? 'Criando...' : 'Criar Usuário' }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <layouts1></layouts1>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import ApiService from '@/services/ApiService';
import Swal from 'sweetalert2';

const router = useRouter();

const title = ref('Criar Usuário');
const text = ref('Home');
const text1 = ref('Criar Usuário');

const courses = ref([]);
const loadingCourses = ref(false);
const saving = ref(false);

const formData = ref({
  email: '',
  fullName: '',
  phone: '',
  userOrigin: null,
  function: '',
  password: '',
  courseIds: []
});

const fetchCourses = async () => {
  loadingCourses.value = true;
  try {
    const response = await ApiService.get('/courses/me');
    courses.value = response.data || [];
  } catch (err) {
    console.error('Error fetching courses:', err);
    Swal.fire({
      icon: 'error',
      title: 'Erro',
      text: 'Erro ao carregar cursos. Por favor, tente novamente.'
    });
  } finally {
    loadingCourses.value = false;
  }
};

const validateForm = () => {
  if (!formData.value.email || !formData.value.email.includes('@')) {
    return { valid: false, message: 'Email inválido' };
  }
  if (!formData.value.fullName || formData.value.fullName.trim().length === 0) {
    return { valid: false, message: 'Nome completo é obrigatório' };
  }
  if (!formData.value.password || formData.value.password.length < 6) {
    return { valid: false, message: 'Senha deve ter no mínimo 6 caracteres' };
  }
  return { valid: true };
};

const handleSubmit = async () => {
  const validation = validateForm();
  if (!validation.valid) {
    Swal.fire({
      icon: 'warning',
      title: 'Validação',
      text: validation.message
    });
    return;
  }

  saving.value = true;
  try {
    const payload = {
      email: formData.value.email.trim(),
      fullName: formData.value.fullName.trim(),
      password: formData.value.password,
      courseIds: formData.value.courseIds || []
    };

    if (formData.value.phone && formData.value.phone.trim()) {
      payload.phone = formData.value.phone.trim();
    }

    if (formData.value.userOrigin) {
      payload.userOrigin = formData.value.userOrigin;
    }

    if (formData.value.function && formData.value.function.trim()) {
      payload.function = formData.value.function.trim();
    }

    await ApiService.post('/users/admin/manual', payload);

    Swal.fire({
      icon: 'success',
      title: 'Sucesso!',
      text: 'Usuário criado com sucesso!',
      confirmButtonText: 'OK'
    }).then(() => {
      router.push('/caduceus/dashboard');
    });
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      'Erro ao criar usuário. Por favor, tente novamente.';
    Swal.fire({
      icon: 'error',
      title: 'Erro',
      text: errorMessage
    });
  } finally {
    saving.value = false;
  }
};

onMounted(() => {
  fetchCourses();
});
</script>

<style scoped>
.course-selection {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 15px;
}

.form-check {
  padding: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.form-check:last-child {
  border-bottom: none;
}

.form-check-label {
  margin-left: 8px;
  cursor: pointer;
}
</style>
